import PageWrapper from 'modules/PageWrapper';

type WithPageWrapperProps = {
  isFullPageScroll?: boolean;
};

const withPageWrapper =
  ({ isFullPageScroll }: WithPageWrapperProps = {}) =>
  (WrappedComponent: React.ComponentType) => {
    const WithPageWrapperComponent = () => (
      <PageWrapper isFullPageScroll={isFullPageScroll}>
        <WrappedComponent />
      </PageWrapper>
    );

    return WithPageWrapperComponent;
  };

export default withPageWrapper;
